module.exports = __webpack_public_path__ + "img/new-box-icon.6217150b.png";